module.exports = __webpack_public_path__ + "img/Ticket Counters.3367b457.svg";